.flip-population-primary-card-container{padding-top:10px;padding-right:10px}
/*# sourceMappingURL=flip-population.component-7GBSQTTT.css.map */
